import React from 'react';
import './ReturnHandling.css';
import ReturnHero from './ReturnHero';
import Newsletter from '../Homepage/Newsletter';
import Footer from '../Layouts/Footer';
import Returnspage from './Returnspage';
import RemovalOrdersSection from './RemovalOrdersSection';
import Canonical from '../../seo/Canonical';
import RelatedLinks from '../Common/RelatedLinks';

const ReturnHandling: React.FC = () => {
  return (
    <div className="return-handling-page logistics-page">

      <Canonical baseUrl="https://www.pickpackpro.co.uk" />

      {/* Hero Section */}
      <ReturnHero />
      <Returnspage />
      <RemovalOrdersSection />

      <RelatedLinks
        serviceLinks={[
          { to: '/multi-channel-fulfillment-services', label: 'Multi-channel fulfilment services' },
          { to: '/shopify-fulfillment-services', label: 'Shopify fulfilment services UK' }
        ]}
        blogLink={{
          to: '/blog/how-to-handle-amazon-removal-orders-uk',
          label: 'Amazon removal orders UK — fees & process guide',
        }}
      />

      <Newsletter />
      <Footer />
    </div>
  );
};

export default ReturnHandling;
